import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Button,
  IconButton,
  Drawer,
  List,
  ListItemText,
  useTheme,
  useMediaQuery,
  ListItemButton,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import { NavLink } from 'react-router-dom';
import { useState } from 'react';
import { useThemeMode } from '../../app/theme';

const AdminHeader = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { toggle, mode } = useThemeMode();

  const buttonStyle = {
    color: 'text.primary',
    textTransform: 'none',
    fontWeight: 500,
    '&.active': {
      borderBottom: '2px solid #1976d2',
      borderRadius: 0,
    },
  };

  return (
    <AppBar position="static" color="default" elevation={1}>
      <Toolbar sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <NavLink to="/orders" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
            {mode === 'light' ? <img src="/logo_text-black.png" alt="Логотип" height={30} /> : <img src="/logo_text-wite.png" alt="Логотип" height={30} />}
            <Typography
              variant="h6"
              sx={{
                ml: 1,
                fontWeight: 700,
                color: 'text.primary',
                fontFamily: '"Playfair Display", serif',
              }}
            >
              Admin
            </Typography>
          </NavLink>

          <IconButton onClick={toggle} sx={{ ml: 1 }} color="inherit">
            {mode === 'dark' ? <Brightness7Icon /> : <Brightness4Icon />}
          </IconButton>
        </Box>

        {isMobile ? (
          <>
            <IconButton edge="end" onClick={() => setDrawerOpen(true)} color="inherit">
              <MenuIcon />
            </IconButton>
            <Drawer anchor="right" open={drawerOpen} onClose={() => setDrawerOpen(false)}>
              <Box sx={{ width: 250 }} role="presentation" onClick={() => setDrawerOpen(false)}>
                <List>
                  <ListItemButton component={NavLink} to="/car">
                    <ListItemText primary="Добавить авто" />
                  </ListItemButton>
                  <ListItemButton component={NavLink} to="/wheels">
                    <ListItemText primary="Работа с дисками" />
                  </ListItemButton>
                  <ListItemButton component={NavLink} to="/tyre">
                    <ListItemText primary="Работа с резиной" />
                  </ListItemButton>
                  <ListItemButton component={NavLink} to="/portfolio">
                    <ListItemText primary="Работа с портфолио" />
                  </ListItemButton>
                  <ListItemButton component={NavLink} to="/orders">
                    <ListItemText primary="Заказы" />
                  </ListItemButton>
                  <ListItemButton component={NavLink} to="/telegram">
                    <ListItemText primary="Аккануты для рассылки" />
                  </ListItemButton>

                </List>
              </Box>
            </Drawer>
          </>
        ) : (
          <Box sx={{ display: 'flex', gap: 2 }}>
            <Button component={NavLink} to="/car" sx={buttonStyle}>
              Добавить авто
            </Button>
            <Button component={NavLink} to="/wheels" sx={buttonStyle}>
              Работа с дисками
            </Button>
            <Button component={NavLink} to="/tyre" sx={buttonStyle}>
              Работа с резиной
            </Button>
            <Button component={NavLink} to="/portfolio" sx={buttonStyle}>
              Работа с портфолио
            </Button>
            <Button component={NavLink} to="/orders" sx={buttonStyle}>
              Заказы
            </Button>
            <Button component={NavLink} to="/telegram" sx={buttonStyle}>
              Аккануты для рассылки tg
            </Button>
            <Button component={NavLink} to="/max" sx={buttonStyle}>
              Аккануты для рассылки MAX
            </Button>
          </Box>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default AdminHeader;
